<template>
  <SACModal
    modalClass="setting-action-modal"
    :cardClass="`promo-${actionModalView}`"
    :show="showActionModal"
    :close="() => toggleActionModal(false)"
  >
    <template
      v-if="actionModalView === 'new-promo'"
      #content
    >
      <PromoBuilder
        :close="() => toggleActionModal(false)"
        :currentCorporation="currentCorporation"
        :partnerSettings="partnerSettings"
      />
    </template>
    <template
      v-else-if="actionModalView === 'edit-promo'"
      #content
    >
      <PromoBuilder
        :close="() => toggleActionModal(false)"
        :currentCorporation="currentCorporation"
        :partnerSettings="partnerSettings"
        :selectedPromo="selectedPromo"
      />
    </template>
  </SACModal>
</template>
<script>
import promoMixin from '@shared/mixins/promoMixin';
import SACModal from '@shared/components/sac/SACModal.vue';
import PromoBuilder from './modal/PromoBuilder.vue';

export default {
  name: 'ActionModal',
  components: {
    SACModal,
    PromoBuilder,
  },
  mixins: [promoMixin],
  props: {
    currentCorporation: Object,
    partnerSettings: Object,
  },
};

</script>
<style lang="scss">

.setting-action-modal {
  .ac-card-content {
    display: flex;
    flex-direction: column;
    height: 100%;
    animation: fadeIn 0.5s ease;
    position: relative;
    .ac-header-container {
      padding: 29px 24px 19px 24px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid $NBLUE10;
      .ac-header {
        font-size: 1.25rem;
        font-weight: 500;
      }
      .ac-close-button {
        width: 32px;
        height: 32px;
        border-radius: 6px;
        background-color: $NBLUE10;
        display: flex;
        align-items: center;
        justify-content: center;
        &:hover {
          background-color: $NBLUE20;
        }
        .ac-close {
          width: 10px;
          height: 10px;
        }
      }
    }
    .ac-body-container {
      flex: 1;
      padding: 31px 24px 26px 24px;
     .error-message {
       color: $TOMATO100;
     }
      .ac-body-header {
        font-size: 1.25rem;
        font-weight: 500;
        text-align: center;
        margin-bottom: 25px;
      }
      .ac-body-sub-container {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 1rem;
      }
      .ac-body-tri-container {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        gap: 2rem;
      }
      .ac-input-container {
        margin-right: 0;
        .ac-input-header {
          font-size: 0.875rem;
          font-weight: 500;
          margin-bottom: 3px;
          .ac-input-sub {
            font-size: 0.75rem;
            color: $N50;
          }
          .ac-input-text {
            font-size: 0.85rem;
            color: $N70;
          }
          .required {
            color: $TOMATO100;
          }
        }
        .match-background {
          background: $NBLUE5;
          border-radius: 3px;
          border: unset;
        }
        textarea {
          width: 100%;
          height: 110px;
          padding: 8px 10px;
          border-radius: 2px;
          background-color: $NBLUE5;
          border: none;
          resize: none;
        }
        .ac-input-error {
          color: $TOMATO100;
          font-size: 0.875rem;
        }
      }
      .permission-section {
        border-top:  2px solid $N5;
        margin-top: 1rem;
      }
    }
  }
  .ac-footer-container {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 16px 24px;
    border-top: 1px solid $NBLUE10;
    .ac-form-button {
      padding: 0 16px;
      height: 40px;
      border-radius: 6px;
      background-color: $NBLUE100;
      color: $WHITE;
      font-weight: 600;
      &:hover {
        background-color: $NBLUE90;
      }
    }
    .ac-form-deactivate {
      padding: 0 16px;
      height: 40px;
      border-radius: 6px;
      background-color: $TOMATO100;
      color: $WHITE;
      font-weight: 600;
      margin-right: 10px;
      &:hover {
        background-color: $TOMATO70;
      }
    }
  }
  .ac-overlay {
    border-radius: 12px;
  }
}
</style>
